<template>
  <div class="video-play" :style="componentStyle">
    <div ref="videoRef"  class="videoRef"  :style="{ width, height }"></div>
  </div>
</template> 
<script>
const DEFAULT_WIDTH = "264px";
const DEFAULT_HEIGHT = "148px";

export default {
  props: {
    videoTrack: {
      type: Object,
      default: null
    },
    audioTrack: {
      type: Object,
      default: null
    },
    config: {
      type: Object,
      default: () => {}
    },
    width: {
      type: String,
      default: DEFAULT_WIDTH
    },
    height: {
      type: String,
      default: DEFAULT_HEIGHT
    },
    componentStyle: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {};
  },

  created() {
    this.$nextTick(() => {
    //   console.log("videoTrack", this.videoTrack);
    //   console.log("audioTrack", this.audioTrack);
      if (this.videoTrack) {
        this.videoTrack.play(this.$refs.videoRef, this.config);
      }
      if (this.audioTrack) {
        this.audioTrack.play();
      }
    });
  },

  watch: {
    videoTrack(track) {
      if (track && this.$refs.videoRef) {
        track.play(this.$refs.videoRef);
      }
    },
    audioTrack(track) {
      if (track) {
        track.play();
      }
    }
  },

  beforeUnmount() {
    if (this.videoTrack) {
      this.videoTrack.close();
    }
    if (this.audioTrack) {
      this.audioTrack.close();
    }
  }
};
</script>
<style scoped>
.video-play {
  width: 100%;
  height: 100%; 
}
 .videoRef{
    margin: 0 auto;
  }
</style>